/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap');

import Vue from 'vue'

/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */

// const files = require.context('./', true, /\.vue$/i);
// files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default));

Vue.use(require('bootstrap-vue'));
Vue.use(require('vue-multiselect'));
Vue.use(require('epic-spinners'));

// Moment
const moment = require('moment');
require('moment/locale/' + (window.locale ? window.locale : 'en'));
Vue.use(require('vue-moment'), {moment});

// Telephone input
import VueTelInput from 'vue-tel-input';
import 'vue-tel-input/dist/vue-tel-input.css';
Vue.use(VueTelInput, {
    'preferredCountries': ['it','ch'],
    'inputOptions': {
        // 'dynamicPlaceholder': true,  // Disabilitato in quanto non funziona nella versione attuale di vue-tel-input
        // 'showDialCode': true,
    },
});

// Snotify
import Snotify, { SnotifyPosition } from 'vue-snotify'
const options = {
    global: {
    },
    toast: {
        timeout: 6000,
        bodyMaxLength: 600,
    },
}
Vue.use(Snotify, options);

// New axios function that allows only one call at a time
// https://github.com/axios/axios/issues/1361#issuecomment-534543644
let call = {};
window.axiosOnce = (config = {}, requestType = 'unnamed') => {
    if (call[requestType]) {
        call[requestType].cancel("Only one request allowed at a time. Cancelling first.");
    }
    call[requestType] = axios.CancelToken.source();
    config.cancelToken = call[requestType].token

    return axios(config);
}

// Simple Vue Validator
import SimpleVueValidation from 'simple-vue-validator';
SimpleVueValidation.setMode('conservative');
Vue.use(SimpleVueValidation);
const validatorLocale = require('./components/locale/simple-vue-validator-'+(window.locale ? window.locale : 'en'));
Vue.prototype.$validator = SimpleVueValidation.Validator.create({templates: validatorLocale});


Vue.prototype.$isInIframe = function () {
    try {
        return window.self !== window.top;
    } catch (e) {
        return true;
    }
};

// Query string
// https://stackoverflow.com/questions/22258793/set-url-parameters-without-causing-page-refresh/22265753#22265753
const queryString = require('query-string');
queryString.push = function (key, new_value) {
    var params = queryString.parse(location.search);
    params[key] = new_value;
    var new_params_string = queryString.stringify(params)
    history.pushState({}, "", window.location.pathname + '?' + new_params_string);
}
queryString.pushOverwrite = function (params) {
    var new_params_string = queryString.stringify(params)
    history.pushState({}, "", window.location.pathname + '?' + new_params_string);
}
queryString.remove = function (key) {
    var params = queryString.parse(location.search);
    delete params[key];
    var new_params_string = queryString.stringify(params)
    history.pushState({}, "", window.location.pathname + '?' + new_params_string);
}
Vue.prototype.$queryString = queryString;

import VueInternationalization from 'vue-i18n';
import Locale from './vue-i18n-locales.generated';
Vue.use(VueInternationalization);

const i18n = new VueInternationalization({
    locale: (window.locale ? window.locale : 'en'),
    messages: Locale
});

// Vue.use(require('vee-validate'));
// import { localize } from 'vee-validate';
// import en from 'vee-validate/dist/locale/en.json';
// import it from 'vee-validate/dist/locale/it.json';
// localize({
//     en,
//     it
// }, (window.locale ? window.locale : 'en'));

// Vue.component(
//     'ResourceType',
//     require('./components/booking/types/ResourceType.vue').default
// );

// require('./components/booking/types/ResourceType.vue').default


Vue.component(
    'resource-booking-box-list',
    require('./components/booking/ResourceBookingBoxList.vue').default
);

Vue.component(
    'resource-booking-popup',
    require('./components/booking/ResourceBookingPopup.vue').default
);

Vue.component(
    'resource-booking-box',
    require('./components/booking/ResourceBookingBox.vue').default
);

Vue.component(
    'resource-booking-box-button',
    require('./components/booking/ResourceBookingBoxButton.vue').default
);

Vue.component(
    'resource-booking-box-next-availability-button',
    require('./components/booking/ResourceBookingBoxNextAvailabilityButton.vue').default
);

Vue.component(
    'resource-booking-checkout',
    require('./components/booking/ResourceBookingCheckout.vue').default
);

// TODO: Da togliere?
// Vue.component(
//     'payment-checkout-card',
//     require('./components/stripe/PaymentCheckoutCard.vue').default
// );

// TODO: Da togliere?
// Vue.component(
//     'payment-card',
//     require('./components/stripe/PaymentCard.vue').default
// );

// Filtri
Vue.filter('nl2br', function (value) {
    return value.replace(/(\r\n|\n|\r)/g,"<br />");
});

Vue.filter('formatDate', function(value) {
    if (value) {
        return moment(String(value)).format('DD/MM/YYYY')
    }
    return null;
});

Vue.filter('capitalize', function (value) {
    if (!value) {
        return '';
    }
    value = value.toString();

    return value.charAt(0).toUpperCase() + value.slice(1);
})

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */


// import moment from 'moment'
const app = new Vue({
    el: '#app',
    i18n,
    created () {
        if (this.$isInIframe()) {
            document.body.classList.add('iframe');
        }
        document.body.classList.remove('loading');
        // // moment.locale(window.locale);
        // moment.locale('it');
        // console.log(this.$moment());
        // console.log(this.$moment().locale());
        // this.$moment.locale('it');
        // console.log(this.$moment().locale());
        // this.$moment.locale('es');
        // console.log(this.$moment().locale());
        // this.$forceUpdate()
        // console.log(this.$moment().locale());
    },
    mounted () {
        // Usato quando viene passato un messaggio in sessione tramite notify_message()
        if (window.notifyMessage) {
            var dynamicTimeout = 6000;
            let textWords = window.notifyMessage.split(' ').length;
            dynamicTimeout = Math.max(dynamicTimeout, textWords * 250);

            switch (window.notifyType) {
                case 'warning':
                    this.$snotify.warning(window.notifyMessage, {
                        timeout: dynamicTimeout,
                    });
                break;

                case 'success':
                    this.$snotify.success(window.notifyMessage, {
                        timeout: dynamicTimeout,
                    });
                break;

                case 'error':
                    this.$snotify.error(window.notifyMessage, {
                        timeout: dynamicTimeout,
                    });
                break;

                case 'info':
                    this.$snotify.info(window.notifyMessage, {
                        timeout: dynamicTimeout,
                    });
                break;

                case 'simple':
                default:
                    this.$snotify.simple(window.notifyMessage, {
                        timeout: dynamicTimeout,
                    });
                break;
            }
        }
    },
});

global.vm = app;
